module.exports = __webpack_public_path__ + "img/wfImg.6617f8c9.png";